import React, { useState } from "react"
import { useTranslation } from "react-i18next"
import { connect } from "react-redux"
import BubbleOptions from "./styled/BubbleOptions"
import TransferBubbleControls from "./styled/TransferBubbleControls"
import ConfirmationDialog from "../ConfirmationDialog"
import { requestCancelUpload } from "../../state/modules/upload"
import { useTimelineEventData } from "../TimelineEventDataProvider"
import { Tooltip } from "react-tooltip"

const CancelUploadButton = ({ cancelUpload }) => {
  const { t } = useTranslation("generic")
  const { uuid } = useTimelineEventData()

  const [showDialog, setShowDialog] = useState(false)

  return (
    <>
      <TransferBubbleControls>
        <BubbleOptions
          as="button"
          data-tooltip-id="canceluploadbutton_tooltip"
          data-tooltip-content={t("##.Upload.Cancel")}
          $cancel={true}
          onClick={() => setShowDialog(true)}
        >
          <span>×</span>
        </BubbleOptions>
        <Tooltip id="canceluploadbutton_tooltip" />
      </TransferBubbleControls>
      <ConfirmationDialog
        isOpen={showDialog}
        modalProps={{
          title: t("##.Upload.CancelUploadHeaderMessage"),
          body: t("##.Upload.CancelUploadBodyMessage"),
          ok: t("##.Upload.CancelUploadButtonCancel"),
          cancel: t("##.Upload.CancelUploadButtonKeep"),
          danger: true,
        }}
        accept={() => {
          cancelUpload(uuid)
          setShowDialog(false)
        }}
        dismiss={() => setShowDialog(false)}
      ></ConfirmationDialog>
    </>
  )
}

const mapDispatchToProps = dispatch => {
  return {
    cancelUpload: uuid => dispatch(requestCancelUpload(uuid)),
  }
}

export default connect(null, mapDispatchToProps)(CancelUploadButton)
